import React, { memo, useCallback } from 'react';
import { Keyboard, TouchableOpacity, View } from 'react-native';
import Text from 'design-system/Text';
import Logo from 'design-system/Logo';
import Modal from 'utils/packages/Modal';
import { hitSlopS, rem, Spacer } from 'design-system';
import IconTooltip from 'design-system/icons/IconTooltip';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import { formatNumberOfShares } from '../utils';
import { useStockMeta } from '../hooks/selectors';
import { commonToolTipStrings } from '../constants';
const BuyAssetRow = ({ assetId, sharesEstimated }) => {
    const styles = useStyles(styleSet);
    const stockCache = useStockMeta(assetId);
    const onInfoButtonPress = useCallback(() => {
        Keyboard.dismiss();
        Modal.showConfirmation({
            title: commonToolTipStrings.noOfSharesTitle,
            subtitle: commonToolTipStrings.noOfSharesWithoutFxFeeDesc,
            confirmButtonTitle: 'Okay',
        });
    }, []);
    return (<TouchableBounceCard onDark disabled noMarginTop noMarginBottom style={styles.cardBtn}>
      <View style={styles.row}>
        <Logo R44 uri={stockCache?.iconUrl} resizeMode="contain"/>
        <Spacer w={16}/>
        <View style={styles.flex}>
          <Text Text-16 numberOfLines={1}>
            {stockCache?.name}
          </Text>
          <View style={styles.infoRow}>
            <Text TextThin-14 Secondary>
              {formatNumberOfShares(sharesEstimated ?? 0, true)} (est.)
            </Text>
            <Spacer w={4}/>
            <TouchableOpacity onPress={onInfoButtonPress} hitSlop={hitSlopS}>
              <IconTooltip colorKey="secondary" width={16} height={16}/>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </TouchableBounceCard>);
};
const styleSet = createStyleSheets(() => ({
    cardBtn: {
        paddingVertical: rem(24),
        paddingHorizontal: rem(16),
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    flex: {
        flex: 1,
    },
    infoRow: {
        alignItems: 'center',
        flexDirection: 'row',
    },
}));
export default memo(BuyAssetRow);
